export default __webpack_public_path__ + "static/media/1-6@2x.c554108b.png";